import { Observable } from 'rxjs';
/**
 * Upload array of files to specified destination
 * @param targetUrl Destionation url
 * @param files Files array
 */
export function uploadFiles(targetUrl, files, formDataPrefix = 'file') {
    const formData = new FormData();
    const request = new XMLHttpRequest();
    files.map((file, i) => formData.append(`${formDataPrefix}.${i}`, file));
    const result$ = Observable.create((observer) => {
        function onLoad(e) {
            if (request.readyState === 4 && request.status >= 200 && request.status < 300) {
                observer.next({
                    files: request.response ? JSON.parse(request.response) : [],
                    totalBytes: e.total,
                    uploadedBytes: e.loaded,
                    percentUpload: (e.loaded / e.total) * 100
                });
                observer.complete();
            }
            else {
                observer.error();
            }
        }
        function onProgress(e) {
            observer.next({
                totalBytes: e.total,
                uploadedBytes: e.loaded,
                percentUpload: (e.loaded / e.total) * 100
            });
        }
        function onError() {
            observer.error();
        }
        function cancelRequest() {
            request.removeEventListener('error', onError);
            request.removeEventListener('load', onLoad);
            if (request.upload) {
                request.upload.removeEventListener('progress', onProgress);
            }
            request.abort();
        }
        request.withCredentials = true;
        request.addEventListener('load', onLoad);
        request.upload.addEventListener('progress', onProgress);
        request.addEventListener('error', onError);
        request.open('POST', targetUrl);
        request.send(formData);
        return () => {
            cancelRequest();
        };
    });
    return result$;
}
//# sourceMappingURL=upload.js.map